import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect } from "react";
import { IWebsiteBuilderWebsite } from "redux/reducers/models/websiteBuilder";
import { useHistory } from "react-router";
import { TWebsiteBuilderWebsiteLoadingStatus } from "redux/reducers/websiteBuilder/websiteBuilderConfig";
import { websiteBuilderLoadWebsite, websiteBuilderSetWebsite } from "redux/actions/websiteBuilder/config/websiteBuilderConfig";
import { useTranslation } from "react-i18next";

interface IUseWebsiteArgs {
  websiteMustExist: boolean;
}

interface IUseWebsite {
  website: IWebsiteBuilderWebsite;
  websiteExists: boolean;
  websiteLoadingStatus: TWebsiteBuilderWebsiteLoadingStatus;
  setWebsite: (website: IWebsiteBuilderWebsite) => void;
}

export function useWebsite(args: IUseWebsiteArgs): IUseWebsite {
  const history = useHistory();
  
  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const facilityStore = useAppSelector(store => store.facilityStore);

  const { website, websiteExists, websiteLoadingStatus } = useAppSelector(store => store.websiteBuilderStore.config);

  useEffect(() => {
    if (facilityStore.facility?.id != null && websiteLoadingStatus === "standby") {
      void dispatch(websiteBuilderLoadWebsite(facilityStore.facility.id, t));
    }
  }, [facilityStore.facility?.id, websiteLoadingStatus]);

  useEffect(() => {
    if (
      websiteLoadingStatus === "failed" ||
      (websiteLoadingStatus === "succeeded" && args.websiteMustExist && !websiteExists)
    ) {
      history.push("/admin/website-builder");
    }
  }, [websiteLoadingStatus, args.websiteMustExist, websiteExists]);

  function setWebsite(website: IWebsiteBuilderWebsite) {
    dispatch(websiteBuilderSetWebsite({ website }));
  }

  return {
    website,
    websiteExists,
    websiteLoadingStatus,
    setWebsite,
  };
}
